/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CatalogAssociationsRequest } from '../../models/catalog-associations-request';

export interface UpsertCatalogEntryIdAssociations$Params {
  'Active-Tenant-Identifier': string;

/**
 * TCE catalogEntryId unique identifier
 */
  catalogEntryId: string;
  
    /**
     * TCE tag service
     */
    body?: CatalogAssociationsRequest
}

export function upsertCatalogEntryIdAssociations(http: HttpClient, rootUrl: string, params: UpsertCatalogEntryIdAssociations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, upsertCatalogEntryIdAssociations.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('catalogEntryId', params.catalogEntryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

upsertCatalogEntryIdAssociations.PATH = '/catalogs/{catalogEntryId}/associations';
